/** Strip the IATA carrier prefix from a REAL flight number for display:
 *  "UA2389" -> "2389", "AA 160" -> "160". Returns "" (honest absence — caller
 *  shows the airline only) for anything that is NOT a real flight number: null,
 *  empty, or a synthetic placeholder ("AA-0600", "UA-1554-1") — real numbers never
 *  contain a dash. A bare numeric form ("2389") is kept as-is. */
export function displayFlightNumber(flightNumber: string | null | undefined): string {
  if (!flightNumber) return "";
  const s = flightNumber.trim();
  const m = s.match(/^[A-Z]{2,3}\s?(\d{1,4}[A-Z]?)$/);
  if (m) return m[1];
  if (/^\d{1,4}[A-Z]?$/.test(s)) return s; // bare number (no carrier prefix)
  return ""; // dash-forms / carrier-only / junk are not real flight numbers → hide
}
